import { render, staticRenderFns } from "./PDPDiscussion.vue?vue&type=template&id=95bbada4&scoped=true&"
import script from "./PDPDiscussion.vue?vue&type=script&lang=js&"
export * from "./PDPDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./PDPDiscussion.vue?vue&type=style&index=0&id=95bbada4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bbada4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PDPSearch: require('/app/appsumo/nuxt/components/pdp/discussion/PDPSearch.vue').default,PDPCommentTabs: require('/app/appsumo/nuxt/components/pdp/discussion/PDPCommentTabs.vue').default,PDPCommentModal: require('/app/appsumo/nuxt/components/pdp/comment-modal/PDPCommentModal.vue').default,PDPQuestionModal: require('/app/appsumo/nuxt/components/pdp/question/PDPQuestionModal.vue').default})
